import React, { Fragment, useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { postData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Button from '@mui/material/Button';
import './CustomDatePicker.css';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const StaffCreate = (props) => {
    const history = useHistory();
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();
    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

    }, [isAuthenticated, companyId, token, logout]);

    const [selectedDate, setSelectedDate] = useState(null);

    const handleDateChange = (e) => {
        setSelectedDate(e.target.value);
    };


    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [contactNumber, setContactNumber] = useState("");
    const [email, setEmail] = useState("");
    const [code, setCode] = useState("");
    const [isLoginNeeded, setIsLoginNeeded] = useState(false);
    const [dateOfJoining, setDateOfJoining] = useState("");
    const [dateOfLeaving, setDateOfLeaving] = useState("");
    const [dOB, setDOB] = useState("");

    const [isSubmit, setIsSubmit] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");


    const clearForm = () => {
        setFirstName("");
        setLastName("");
        setContactNumber("");
        setEmail("");
        setDateOfJoining("");
        setDateOfLeaving("");
        setDOB("");
        setCode("");
    };

    // const submitData = async (e) => {
    //     e.preventDefault();

    //     // if (!isSubmit) {
    //     //     return;
    //     // }

    //     if (!firstName) {
    //         setErrorMessage('First Name is required !');
    //         // setIsSubmit(false);
    //         return;
    //     }

    //     if (!lastName) {
    //         setErrorMessage('Last Name is required !');
    //         //  setIsSubmit(false);
    //         return;
    //     }

    //     if (!contactNumber) {
    //         setErrorMessage('Contact Number is required !');
    //         // setIsSubmit(false);
    //         return;
    //     }

    //     if (!email) {
    //         setErrorMessage('Email is required !');
    //         //setIsSubmit(false);
    //         return;
    //     }
    //     const loginNeededValue = isLoginNeeded ? "Yes" : "No";

    //     const CreateData = {
    //         FirstName: firstName,
    //         LastName: lastName,
    //         Code: code,
    //         Email: email,
    //         ContactNumber: contactNumber,
    //         DateOfJoining: dateOfJoining,
    //         DateOfLeaving: dateOfLeaving,
    //         DOB: dOB,
    //         CreatedBy: userId,
    //         CompanyID: companyId,
    //         CreatedDate: new Date(),
    //         IsLoginNeeded: loginNeededValue,
    //     };

    //     postData('StaffApi', CreateData, token)
    //         .then((response) => {
    //             console.log('Staff Created success:', response);
    //             setSuccessMessage("Staff Created successfully!");
    //             setErrorMessage("");
    //             clearForm();
    //             history.push('/StaffIndex');
    //             setTimeout(() => {
    //                 setSuccessMessage("");
    //             }, 3000);
    //         })
    //         .catch((error) => {
    //             console.error('Staff Create error:', error);
    //         });
    // };

    const submitData = async (e) => {
        e.preventDefault();

        if (!firstName || !lastName || !contactNumber || !email) {
            setErrorMessage('All fields marked with * are required!');
            return;
        }

        // const loginNeededValue = isLoginNeeded ? "true" : "false";

        const CreateData = {
            FirstName: firstName,
            LastName: lastName,
            Code: code,
            Email: email,
            ContactNumber: contactNumber,
            DateOfJoining: dateOfJoining,
            DateOfLeaving: dateOfLeaving,
            DOB: dOB,
            CreatedBy: userId,
            CompanyID: companyId,
            CreatedDate: new Date(),
            IsLoginNeeded: isLoginNeeded,
        };

        postData('StaffApi', CreateData, token)
            .then((response) => {
                console.log('Staff Created success:', response);
                setSuccessMessage("Staff Created successfully!");
                setErrorMessage("");
                clearForm();
                history.push('/StaffIndex');
                setTimeout(() => {
                    setSuccessMessage("");
                }, 3000);
            })
            .catch((error) => {
                console.error('Staff Create error:', error);
                if (error.response) {
                    // Handle validation errors from the server
                    const errors = error.response.data;
                    if (errors && errors.length > 0) {
                        setErrorMessage(errors.join('\n'));
                    } else {
                        setErrorMessage("Oops! Something went wrong.");
                    }
                } else {
                    setErrorMessage("Oops! Something went wrong.");
                }
            });
    };


    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-6 mx-auto">
                <form onSubmit={submitData}>

                    <div className='w-full mb-2 flex items-center'>
                        <h6 className='productHead flex-grow linkcolor' style={{ color: 'black', fontFamily: 'Georgia, serif', fontWeight: 'bolder' }}>STAFF CREATE</h6>
                        <Button

                            component={Link}
                            to="/StaffIndex"
                            className="linkcolor"
                            style={{ marginLeft: '8px', color: 'brown', fontWeight: 'bolder' }}
                        >
                            Back To List  <ArrowForwardIosIcon />
                        </Button>
                        <Button

                            style={{ marginLeft: '8px', color: 'darkgreen', fontWeight: 'bolder' }}
                            onClick={submitData}
                        >
                            SAVE <CheckCircleIcon />
                        </Button>


                    </div>
                    {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                    {successMessage && <p className="text-green-500">{successMessage}</p>}


                    <div className="w-full mb-4 flex">
                        <div className="w-1/4 mr-2">
                            <label className="block  tracking-wide text-black text-base font-bold mb-2" htmlFor="code">
                                First Name
                                <span className="text-red-500">*</span>
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline "
                                value={firstName}
                                onChange={(e) => setFirstName(e.target.value)}
                                type="text" placeholder="Enter First Name"
                                maxLength={30}
                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block  tracking-wide text-black text-base font-bold mb-2" htmlFor="code">
                                Last Name
                                <span className="text-red-500">*</span>
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline "
                                value={lastName}
                                onChange={(e) => setLastName(e.target.value)}
                                type="text" placeholder="Enter Last Name"
                                maxLength={30}
                            />
                        </div>
                        <div className="w-1/7 mr-2">
                            <label className="block  tracking-wide text-black text-base font-bold mb-2" htmlFor="code">
                                Code
                                <span className="text-red-500">*</span>
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline "
                                value={code}
                                onChange={(e) => setCode(e.target.value)}
                                type="text" placeholder="Enter Code"

                            />
                        </div>
                        <div className="mr-2">
                            <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="fromDate" style={{ fontSize: '16px' }}>
                                DateOfJoining
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="date" value={dateOfJoining} onChange={(e) => setDateOfJoining(e.target.value)}

                            />
                        </div>

                    </div>
                    <div className="w-full mb-4 flex">
                        <div className="mr-2">
                            <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="fromDate" style={{ fontSize: '16px' }}>
                                DOB
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="date" value={dOB} onChange={(e) => setDOB(e.target.value)}

                            />
                        </div>
                        <div className="w-1/7 mr-3">
                            <label className="block  tracking-wide text-black text-base font-bold mb-2" htmlFor="code">
                                Ph.Number
                                <span className="text-red-500">*</span>
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline "
                                value={contactNumber}
                                onChange={(e) => setContactNumber(e.target.value)}
                                type="text" placeholder="Enter Contact Number"
                                maxLength={15}
                            />
                        </div>
                        <div className="w-1/4 mr-2">
                            <label className="block  tracking-wide text-black text-base font-bold mb-2" htmlFor="code">
                                Email
                                <span className="text-red-500">*</span>
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline "
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                type="text" placeholder="Enter Email"
                                maxLength={40}
                            />
                        </div>

                        <div className="mr-2">
                            <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="fromDate" style={{ fontSize: '16px' }}>
                                DateOfLeaving
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="date" value={dateOfLeaving} onChange={(e) => setDateOfLeaving(e.target.value)}

                            />
                        </div>
                        <div className="w-1/4 mr-2 flex items-center">
                            <div className="form-group">
                                <span style={{ marginRight: '5px', marginTop: '25px', fontWeight: 'bolder' }}>Login Needed</span>
                                <input
                                    type="checkbox"
                                    style={{ marginTop: '15px' }}
                                    checked={isLoginNeeded}
                                    onChange={(e) => setIsLoginNeeded(e.target.checked)}
                                />
                            </div>
                        </div>


                    </div>

                </form>
            </div>
        </Fragment>
    );
}

export default StaffCreate;

